import { Listbox } from '@headlessui/react';
import { setDefaultOptions } from 'date-fns';
import { enUS, id } from 'date-fns/locale';
import i18n from 'i18next';
import { useEffect, useState } from 'react';
import { Icon } from '@iconify/react';

const locales = { en: enUS, id };

const LanguageSwitcher = ({ containerClassName, color = null }) => {
  const [activeLanguage, setActiveLanguage] = useState(i18n.language);

  const handleSwitchLanguage = (lang) => {
    setDefaultOptions({ locale: locales[lang] });
    i18n.changeLanguage(lang);
  };

  useEffect(() => setActiveLanguage(i18n.language), [i18n.language]);

  return (
    <div className={`${containerClassName} relative inline-flex items-center rounded-md space-x-1`}>
      <Listbox as="div" value={activeLanguage} onChange={handleSwitchLanguage}>
        <Listbox.Button className="p-3 border rounded-full hover:bg-gray-100">
          <Icon icon="lucide:globe" width={20} height={20} style={{ color }} />
        </Listbox.Button>
        <Listbox.Options className="absolute overflow-hidden text-black bg-white border rounded-md shadow-md -left-1 top-12">
          {LanguageSwitcher.languageOptions.map(({ value, label }) => (
            <Listbox.Option
              key={value}
              value={value}
              className="px-5 py-2 text-sm cursor-pointer ui-selected:bg-gray-50 hover:bg-gray-100"
            >
              {label}
            </Listbox.Option>
          ))}
        </Listbox.Options>
      </Listbox>
      <div className="font-medium uppercase" style={{ color }}>
        {activeLanguage}
      </div>
    </div>
  );
};

LanguageSwitcher.languages = {
  en: {
    label: 'EN',
    description: 'English',
    value: 'en',
  },
  id: {
    label: 'ID',
    description: 'Bahasa Indonesia',
    value: 'id',
  },
};

LanguageSwitcher.languageOptions = Object.values(LanguageSwitcher.languages);

LanguageSwitcher.defaultProps = {
  className: '',
  containerClassName: '',
};

export default LanguageSwitcher;
